import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ShowErrorComponent } from '../show-error/show-error.component';

@Component({
  selector: 'app-input-textarea',
  imports: [CommonModule, ReactiveFormsModule, ShowErrorComponent],
  templateUrl: './input-textarea.component.html',
  styles: ``
})
export class InputTextareaComponent {
  @Input() label!: string;
  @Input() placeholder = '';
  @Input() rows: number = 4;
  @Input() showError = true;
  @Input() control!: FormControl | AbstractControl | null;

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get normalizedFieldName(): string {
    if (!this.label) return '';
    if (this.label === this.label.toUpperCase()) {
      return this.label;
    }
    return this.label.charAt(0).toLowerCase() + this.label.slice(1);
  }

  get isRequired(): boolean {
    if (!this.control || !this.control.validator) return false;
    const validator = this.control.validator({} as any);
    return validator?.['required'] === true;
  }
}
